import React, { useState, useContext,  } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { ResetPasswordValidator } from "./resetPasswordValidator";
import { Prevbutton, EyeIcon } from "../../../assets/images";
import { Input, Button, PageHeader } from "../../../components/";
import { EndPoints } from "../../../api";
import axios from "axios";
import { AlertContext } from "../../../context/context";
import {
  loginButtonWrapper,
  loginEmailWrap,
  loginPasswordWrap,
  prevbuttonWrapper,
  loginSupportWrapper,
  loginSupportText,
  loginSupportLink,
  loginForm,
} from "../login/login.module.css";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setAlertState } = useContext(AlertContext);

  const search = useLocation().search;

  const token = new URLSearchParams(search).get("token");

  const handleOnSubmit = () => {
    setLoading(true);

    axios
      .post(EndPoints.resetPassword, values, {
        headers: {
          "x-auth-token": token,
        },
      })
      .then((res) => {
        if (res.data.success) {
          setAlertState({
            show: true,
            labelText: "Password reset succesfully. Please login again",
            failure: false,
            status: "Success",
            type: "Password Reset",
          });
          history.push("/login");
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        toast.error(err?.response?.data?.message);
        setLoading(false);
      });
  };

  const { values, errors, handleChange, handleSubmit, touched } = useFormik({
    initialValues: { new_password: "", confirm_new_password: "" },
    validationSchema: ResetPasswordValidator,
    onSubmit: handleOnSubmit,
  });

  const history = useHistory();
  return (
    <form className={loginForm} onSubmit={handleSubmit}>
      <Link to="/">
        <div className={prevbuttonWrapper}>
          <img src={Prevbutton} alt="Previous Icon" />
        </div>
      </Link>
      <p>
        <PageHeader
          head="Reset Password"
          text="Reset password to gain access to your profile."
        />
      </p>
      <div className={loginEmailWrap}>
        <Input
          type={showPassword ? "text" : "password"}
          placeholder="New password"
          label="New password"
          name="new_password"
          icon={
            <EyeIcon
              onClick={() => {
                setShowPassword(!showPassword);
              }}
            />
          }
          value={values.new_password}
          onChange={handleChange}
          errorText={touched.new_password ? errors.new_password : ""}
        />
      </div>
      <div className={loginPasswordWrap}>
        <Input
          type={showPassword ? "text" : "password"}
          placeholder="Confirm password"
          label="Confrim password"
          name="confirm_new_password"
          icon={
            <EyeIcon
              onClick={() => {
                setShowPassword(!showPassword);
              }}
            />
          }
          value={values.confirm_new_password}
          onChange={handleChange}
          errorText={
            touched.confirm_new_password ? errors.confirm_new_password : ""
          }
        />
      </div>

      <div className={loginButtonWrapper}>
        <Button
          buttonName={loading ? "Resetting..." : "Reset"}
          main="fill"
          type="submit"
        />
        <div className={loginSupportWrapper}>
          <p className={loginSupportText}>Experiencing Issues?</p>
          <span
            className={loginSupportLink}
            onClick={() => history.push("/contact")}
          >
            Contact support
          </span>
        </div>
      </div>
    </form>
  );
};
export { ResetPassword };
